import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import type { ModuleData } from "@/types/ModuleType";
import {AxiosResponse} from "axios";
import posthog from '@/posthog';
@Module
export default class ModuleModule extends VuexModule {

    errors: {} = {};
    moduleData: ModuleData = {} as ModuleData;
    currentModule: ModuleData = {} as ModuleData;
    moduleAccessDenied: boolean = false;

    get getCurrentModule() {
        return this.currentModule;
    }

    get getModuleAccessDenied() {
        return this.moduleAccessDenied;
    }
    //
    get getModuleData(): ModuleData {
        return this.moduleData;
    }

    @Action
    async [Actions.GET_MODULE_ALL]() {

        try {
            const response: AxiosResponse<any> = await ApiService.get("/academy?");
            this.context.commit(Mutations.SET_MODULE_DATA, response.data);
            posthog.capture('viewed_modules', {});
        } catch (error) {
            this.context.commit(Mutations.SET_MODULE_DATA, {});
        }
    }
    @Action
    async [Actions.GET_MODULE](id: number) {
        try {
            this.context.commit(Mutations.SET_MODULE_ACCESS_DENIED, false);
            const response: AxiosResponse<any> = await ApiService.get("/academy/modules/"+id);
            this.context.commit(Mutations.SET_CURRENT_MODULE_DATA, response.data.data);
            posthog.capture('viewed_module', {
                module_id: id,
                module_name: response.data.data.title,
                in_progress: response.data.data.in_progress,
                is_freemium: response.data.data.is_freemium
            });
        } catch (error: any) {
            if (error.response && error.response.status === 402) {
                this.context.commit(Mutations.SET_MODULE_ACCESS_DENIED, true);
            } else {
                this.context.commit(Mutations.SET_CURRENT_MODULE_DATA, {});
                throw error;
            }
        }
    }
    @Mutation
    [Mutations.SET_MODULE_DATA](moduleData: ModuleData) {
        if(moduleData.lessons) {
            this.moduleData.lessons = moduleData.lessons;
        }

        this.moduleData = moduleData;
    }

    @Mutation
    [Mutations.SET_CURRENT_MODULE_DATA](module: ModuleData) {
        this.currentModule = module;
    }

    @Mutation
    [Mutations.SET_MODULE_ACCESS_DENIED](denied: boolean) {
        this.moduleAccessDenied = denied;
    }

}